import { useState } from "react";
import { Box } from "@mui/material";
import SalaryDashboard from "./SalaryDashboard";
import TasksDashboard from "../Tasks/TasksDashboard";
import { Vocabulary } from "../../Utils/Vocabulary";

const TABS = [
  { label: Vocabulary.tasksName },
  { label: Vocabulary.salary },
];

export default function Dashboard(_props: any) {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 3,
          px: 3,
          pt: 2,
          pb: 1.5,
          background: "#fff",
          borderBottom: "1px solid #f1f3f5",
        }}
      >
        <Box
          sx={{
            display: "inline-flex",
            background: "#e5e7eb",
            borderRadius: "50px",
            padding: "4px",
            gap: "2px",
          }}
        >
          {TABS.map((tab, index) => (
            <Box
              key={tab.label}
              onClick={() => setActiveTab(index)}
              sx={{
                px: 2.5,
                py: 0.75,
                borderRadius: "50px",
                cursor: "pointer",
                fontSize: "0.875rem",
                fontWeight: activeTab === index ? 700 : 500,
                color: activeTab === index ? "#fff" : "#374151",
                bgcolor: activeTab === index ? "#FF6633" : "transparent",
                boxShadow: activeTab === index
                  ? "0 1px 4px rgba(255,102,51,0.30)"
                  : "none",
                transition: "all 0.18s ease",
                userSelect: "none",
                whiteSpace: "nowrap",
                "&:hover": activeTab !== index
                  ? { bgcolor: "rgba(0,0,0,0.07)", color: "#111827" }
                  : {},
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>
      </Box>

      {activeTab === 0 && <TasksDashboard embedded />}
      {activeTab === 1 && <SalaryDashboard name="SalaryDashboard" />}
    </Box>
  );
}
